import { getCreativeTemplateApi } from '@/api/creative';

/**
 * 创意混入
 * @param {Class} Base 基类
 */
export default (Base) => class extends Base {
  /**
   * 获取创意规格列表
   * @param {Object} params 查询参数
   * @returns {Promise<Object[]>}
   */
  async getCreativeTemplateList(params = {}) {
    try {
      const payload = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...params,
      };
      const response = await getCreativeTemplateApi(payload);
      const result = (response?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
};
